import React from "react";

export default function ToolCard({ title, subtitle, children }) {
  return (
    <div className="rounded-3xl border border-emerald-900/10 bg-white p-6 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-base font-semibold text-slate-900">{title}</div>
          {subtitle ? <div className="mt-1 text-sm text-slate-600">{subtitle}</div> : null}
        </div>
      </div>
      <div className="mt-5">{children}</div>
    </div>
  );
}
